import { styled, component } from '../../../utils/style';
import { Format, StyleColor } from '../../../utils/styles-constants';

export const StyledTheaterHeader = styled()(component.div, 'StyledTheaterHeader')`
	display: flex;
	height: 45px;
	box-sizing: border-box;
	color: ${StyleColor.White};
	width: 100%;
	align-items: center;
	flex-direction: row;
	padding: 0 50px;

	@media ${Format.Smartphone} {
		padding: 0 15px;
	}
`;

export const LeftBlock = styled()(component.div, 'LeftBlock')`
	text-align: left;
	flex-basis: 33.3%;
`;

export const CenterBlock = styled()(component.div, 'CenterBlock')`
	text-align: center;
	font-size: 18px;
	font-weight: 100;
	flex-basis: 33.3%;
`;

export const RightBlock = styled()(component.div, 'RightBlock')`
	flex-basis: 33.3%;
	display: flex;
	justify-content: flex-end;
	align-items: center;

	& svg {
		fill: ${StyleColor.White};
	}
`;

export const CloseLabel = styled()(component.span, 'CloseLabel')`
	cursor: pointer;
	font-size: 14px;
	margin-left: 20px;
`;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Theater/Header/styles.ts